var featured_video = (function() {
    // Loop through featured videos
    $(".featured-video").each(function() {
        // Cache the video player and source of the video
        var iframeSrc = $("#video-" + $(this).data("video")).find("iframe").attr("src");
        console.log(iframeSrc);
        // Replace source of video and auto play on click of play button
        $(this).find(".play-video").on("click", function() {
            var targetVideo = $(this).data("target");
            $(".video-bg").fadeIn(100);
            $("#video-" + targetVideo).fadeIn(100);
            $("#video-" + targetVideo)
                .find("iframe")
                .attr("src", iframeSrc + "?autoplay=1&rel=0");
        });
    });
    // On click of the featured video box, except for play button, close video
    $(".featured-video").on("click", function(e) {
        if (!$(e.target).hasClass("fa fa-play-circle-o")) {
            $(this).removeClass("open");
            // Remove video source to stop video from playing
            $(this)
                .find("iframe")
                .attr("src", "");
        }
    });
    // Close videos
    $(".close-video").on("click", function() {
        $(".video-modal, .video-bg").fadeOut(100);
        $(this).parent().find("iframe").attr("src", "");
    })
    $(".video-bg").on("click", function() {
        $(".video-overlay, .video-bg").fadeOut(100);
        $("#banner-video-player").attr("src", "");
    })

    var videoSrc = $("#banner-video-player").attr("src");
    $(".banner.has-video .play-button").on("click", function() {
        // Cache the video player and source of the video
        $(".video-overlay, .video-bg").fadeIn();
        $("#banner-video-player").attr("src", videoSrc + "?autoplay=1&rel=0");
    });
    $(".video-overlay button").on("click", function() {
        $(".video-overlay, .video-bg").fadeOut();
        $("#banner-video-player").attr("src", "");
    })
})();
